import { Component, OnInit, Input, Optional, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-status-popup',
  templateUrl: './status-popup.component.html',
  styleUrls: ['./status-popup.component.scss']
})
export class StatusPopupComponent implements OnInit {

  @Input() changePasswordText: string = '';

  constructor(
    private dialogRef: MatDialogRef<StatusPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogParams
  ) { }

  ngOnInit(): void {
    this.changePasswordText = this.dialogParams?.message;
  }

  closeDialog() {
    this.dialogRef.close()
  }

}
